import OMainFrame from './o-main-frame';

export default OMainFrame;
